import { render, staticRenderFns } from "./ReportsFilter.vue?vue&type=template&id=2b0ea746&scoped=true&"
import script from "./ReportsFilter.vue?vue&type=script&lang=js&"
export * from "./ReportsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ReportsFilter.vue?vue&type=style&index=0&id=2b0ea746&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ea746",
  null
  
)

export default component.exports